import { useEffect, useState } from 'react';
import { getMultipleProductsByIds } from 'api/search';

import { USE_COOKIES_QUEUE_KEYS, useCookieQueue } from 'hooks/useCookieQueue';

import { Product, Root } from 'utils/types';
import RecentBrowsedProductsRenderer from './RecentBrowsedProductsRenderer';

// New hook to fetch products by Virgo IDs
const useRecentlyViewedProductsList = () => {
  const { queue } = useCookieQueue(USE_COOKIES_QUEUE_KEYS.PRODUCTS);
  const ids = queue?.map((item) => item?.id);

  const [data, setData] = useState<Root>({ brands: [], products: [] });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (ids?.length > 0) {
          setIsLoading(true);
          const response: Root = await getMultipleProductsByIds(ids);
          // Sort the response based on the order of ids in the queue
          const sortedData: Product[] = [];
          ids.forEach((id) => {
            const matchingProduct = response?.products?.find((product) => product?.id === id);
            if (matchingProduct) {
              sortedData.push(matchingProduct);
            }
          });

          setData({ ...response, products: sortedData });
        }
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array to ensure it runs only on the first render

  return {
    data,
    error,
    isLoading,
  };
};

export type RecentBrowsedProductsCarouselProps = {
  viewAllRef: string;
  type: string;
  sx: {};
  carouselSettings: any;
};

const RecentBrowsedProductsCarousel = (props: RecentBrowsedProductsCarouselProps) => {
  const { data, isLoading } = useRecentlyViewedProductsList();

  return <RecentBrowsedProductsRenderer data={data} isLoading={isLoading} {...props} />;
};

export default RecentBrowsedProductsCarousel;
